<template>
    <div class="container">
        <div class="header">
            <div class="logo">
                <img class="logo-img" src="@/assets/imgs/logo.png" alt="">
            </div>
            <!-- <div class="tab">
                <div class="tab-item active">
                    <a href="javascript:;">首页</a>
                </div>
                <div class="tab-item">
                    <a href="#prod">产品</a>
                </div>
                <div class="tab-item">
                    <a href="#about">关于我们</a>
                </div>
            </div> -->
        </div>
        <div class="banner">
            <img src="@/assets/imgs/banner.jpg" alt="">
        </div>
        <div class="main">            
            <div class="title" id="prod">
                寓教于乐 智趣结合
            </div>
            <div class="detail">
                符言科技专注休闲益智游戏开发，致力于通过精心设计的游戏激发玩家思维能力、创造力和想象力。我们秉持着“寓教于乐，智趣结合”的理念，为玩家提供丰富多样的益智游戏体验，让玩家在享受游戏乐趣的同时，也能收获知识和成长。<br/>我们不断追求创新，努力打造成为休闲益智游戏领域的领军者。
            </div>               
            <div class="images">           
                <div @click="toApp(0)"><img src="@/assets/imgs/1.png" alt="" ></div>
                <!-- <div @click="toApp(1)"><img src="@/assets/imgs/2.png" alt=""></div> -->
                <div @click="toApp(2)"><img src="@/assets/imgs/3.png" alt=""></div>
            </div>
        </div>
        <div class="footer">
            <div>Copyright © 2024 Fuyan Information Technology Co., Ltd. All Rights Reserved. 
            <a href='https://beian.miit.gov.cn/#/Integrated/index'>浙ICP备2023010987号-3</a></div> 
            <div>版权所有：杭州符言信息科技有限公司&nbsp;&nbsp;
                <img src="@/assets/imgs/gongan.png"><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502007455">浙公网安备 33010502007455号</a>
            </div>
        </div>    
    </div>
</template>
<script>
export default {
    mounted() {
        window.scrollTo({
            top: 0,
            // behavior: 'smooth' // 平滑滚动
        });
    },
    methods: {  
        toApp(appIndex) {  
            console.log(appIndex);
            
            switch (appIndex) {
            case 0: {
                this.$router.push('/sudoku')
            }
            break;
            case 1: {
                this.$router.push('/shuzhi')
            };
            break;
            case 2: {
                this.$router.push('/puzzle')
            };
            break;
            default: break;
        }
    }  
  }  
}
</script>
<style lang="less" scoped>
.container{
    background: #fff;
    min-height: 100vh;
}
.tab{
    height: 73px;
    display: flex;
    align-items: center;
    .tab-item{
        margin-left: 43px;
    }
    .active a{
        color: #0664CD; 
    }
    a{
        font-size: 14px;
        color: #494949;
    }
}
.header{
    width: 1300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    .logo-img{        
        width: 190px;
        height: 40px;
    }
}
.banner{
    height: 619px;
    img{
        width: 100%;
        height: 100%;
    }
}
.main{
    width: 877px;
    margin: 0 auto;
    padding-top: 55px;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
        font-size: 26px;
        font-weight: 400;
    }
    .detail {
        font-size: 18px;
        line-height: 34px;
        font-weight:lighter;
        margin-top: 40px;
        text-align: center;
    }
    .images {
        display: flex;
        margin-top: 55px;
        img {
            width: 300px;
            height: 420px;
            &:last-child {
                margin-left: 80px;
            }
        }
    }
}
.wrap{
    width: 100%;
    position: relative;
    
    img{
        width: 100%;
    }
}
.five {
    margin-top: 110px;
    .desc{
        position: absolute;
        left: 0;
        top:0;
        width: 367px;
    }
    .name{
        font-size: 24px;
        color: #0663CC;
        &:nth-child(1){
            font-size: 22px;
        }
    }
    .words{
        font-size: 13px;
        color: #666666;
        margin-top: 46px;
        text-align: justify;
        line-height: 24px;
    }
}
.footer{
        padding:38px 0 37px;
        position: absolute;        
        width:100%;        
        font-size: 13px;
        color: #FFFFFF;
        background:#060508;
        z-index: 9;
        border-top:1px solid #060508;
    }
    .footer div:first-child{
        letter-spacing: 0.37px;
        text-align: center;
        line-height: 18px;
    }
    .footer div:last-child{
        letter-spacing: 0.37px;
        text-align: center;
        line-height: 18px;
        margin-top: 9px;
    }
    .footer a{
        color: #fff;
    }
    .footer img{
        width: 15px;
        top: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Home.vue